import React from 'react';
import classNames from 'classnames';
import styles from './CenteredText.module.scss';
import { RichText, Container } from 'ui/components';

export interface CenteredTextProps {
    content: string;
    enableFramingLines: boolean;
    className?: string;
    backgroundColor?: string;
    textColor?: string;
    overridePaddingVertical?: number;
	overridePaddingHorizontal?: number;
}

export const CenteredText: React.FC<CenteredTextProps> = ({ 
    className, 
    content, 
    enableFramingLines,
    backgroundColor, 
    textColor, 
    overridePaddingVertical,
    overridePaddingHorizontal
}) => {

    const hasVerticalOverride = overridePaddingVertical !== undefined && overridePaddingVertical > 0;
    const hasHorizontalOverride = overridePaddingHorizontal !== undefined && overridePaddingHorizontal > 0;
  
    const paddingStyle: React.CSSProperties = {};
    (paddingStyle as any).containerType = 'inline-size';
    if (hasVerticalOverride) {
        paddingStyle.paddingTop = `${overridePaddingVertical}%`;
        paddingStyle.paddingBottom = `${overridePaddingVertical}%`;
    }
    if (hasHorizontalOverride) {
        paddingStyle.paddingLeft = `${overridePaddingHorizontal}%`;
        paddingStyle.paddingRight = `${overridePaddingHorizontal}%`;
    }
    return (
        <div style={{ 
            backgroundColor: backgroundColor && isValidHex(backgroundColor) ? backgroundColor : undefined 
        }}>
            <div style={{ ...paddingStyle, 
                    color: textColor && isValidHex(textColor) ? textColor : undefined }}
                className={classNames(
                    { [styles.FramingLines]: enableFramingLines },
                    { [styles.FramingLines___withVerticalLine]: enableFramingLines && !hasHorizontalOverride }
                )}>
                <Container 
                    width={hasHorizontalOverride ? "Full width" : "Standard"}
                    className={classNames(
                    styles.CenteredText_container,
                    { [styles.CenteredText_container___overridePaddingVertical]: hasVerticalOverride && !hasHorizontalOverride },
                    { [styles.CenteredText_container___overridePaddingHorizontal]: hasHorizontalOverride && !hasVerticalOverride },
                    { [styles.CenteredText_container___overridePadding]: hasVerticalOverride && hasHorizontalOverride }
                )}
                >
                    <div className={classNames(styles.CenteredText, className)}>
                        <RichText 
                            className={styles.CenteredText} 
                            content={content} 
                            textColor={textColor}
                        />
                    </div>
                </Container>
            </div>
        </div>
    );
};

const isValidHex = (color: string) => /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
